<template>    
        <!-- possible: close-delay or open-delay ( in ms ) -->
        <BaseTooltip :disabled="tooltipText ? false : true">
            <template v-slot:content>
                <v-btn 
                    :color="color"
                    @click="click"
                    text 
                    icon
                    :href="href"
                    :to="to" 
                    :disabled="disabled"
                    :loading="loading"
                ><v-icon :small="small" :id="id" :alvqa="alvqa">{{ icon }}</v-icon></v-btn>
            </template>
            <template v-slot:text>
                {{ $alvPlugin.isLangConst(tooltipText) ? $t(tooltipText) : tooltipText }}
            </template>
        </BaseTooltip>
</template>

<script>
import VBtn from 'vuetify/es5/components/VBtn'
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
    name: "BaseIcon",
    extends: VBtn,
    components: {
        BaseTooltip
    },
    props: {
        tooltipText: String,
        icon: String,
        color: {
            default: "iconStandard",
            type: String
        },
        small: {
            type: Boolean,
            default: false
        },
        id: String,
        alvqa: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    }
}
</script>